// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1PPgY","search":"Settings_search__3wJoZ","filter":"Settings_filter__3wgBT"};